import { useParams } from "react-router-dom";

function useProjectCode () {
    let { id } = useParams();
    return id
}

export default useProjectCode